<script>
	import { getText } from '../../../../share/utils';
</script>

<div class="page-health-insurance marginbox">
	<div class="flex structure">

		<div class="flex row structure-1 visible--desktop">
			<div class="flex element">
				<img loading="lazy" alt="AOK - Wallpaper" src="./../img/17.Health_And_Care/04.insurance/Wallpaper_90090_50KB.webp">
			</div>
		</div>
		
		<div class="flex row structure-3">
			<div class="flex structure-3-1">
				<div class="w_80 right">
					<h2 class="caption">{getText("17.04.01_h2")}</h2>
					<p class="text caption">{getText("17.04.02_caption")}</p>
				</div>

				<div class="flex col element text overflow">
					<h2 class="balance">{getText("17.04.03_quote")}</h2>
					<p class="caption">Prentice Mulford</p>
				</div>
			</div>
			
			<div class="flex structure-3-2">
				<div class="flex element">
					<img loading="lazy" alt="AOK - rect-Ad-Vorlage" src="./../img/17.Health_And_Care/04.insurance/medium_rect_vorlage.webp">
				</div>
				<div class="flex element">
					<img loading="lazy" alt="AOK - Banner-Ad" src="./../img/17.Health_And_Care/04.insurance/Banner_320480_50KB.webp">
				</div>
				<div class="flex element visible--desktop">
					<img loading="lazy" alt="AOK - Wallpaper" src="./../img/17.Health_And_Care/04.insurance/Wallpaper_160600_50KB.webp">
				</div>
			</div>
		</div>
	</div>
</div>

<style lang="scss">
	@import "../../../../style/mixins";
	@import "../../../../style/variables";
	
	img {
		width: 100%;
		margin: 0;
		padding: 0;
	}
	
	.page-health-insurance {
		.flex {
			display: flex;
			box-sizing: border-box;
		}
		
		.row {
			flex-flow: row wrap;
		}
		
		.col {
			flex-flow: column wrap;
		}
		
		.element {
			min-width: 100px;
		}
		
		.structure {
			flex-flow: row wrap;
		}
		
		.structure-1,
		.structure-2,
		.structure-3 {
			width: 100%;
			padding: 0;
			position: relative;
			
			> .element {
				width: 100%;
				height: fit-content;
			}
		}
		
		.structure-1 {
			justify-content: end;
			
			> .element {
				max-width: 905px;
			}
		}
		
		.structure-2 {
			justify-content: space-between;
			
			> .element:first-of-type {
				flex-basis: 60%;
				align-self: flex-end;
				
				@include for-tablet-portrait-up {
					flex-basis: 35%;
					padding-bottom: $spacing-mobile*2;
				}
			}
			
			> .element:nth-of-type(2) {
				flex-basis: 20%;
				min-width: unset;
			}
		}
		
		.structure-3 {
			margin-bottom: $spacing-mobile-half;
			
			@include for-tablet-portrait-up {
				flex-flow: row nowrap;
				margin-bottom: 0;
			}
			
			.structure-3-1 {
				margin: $spacing-mobile-half 0;
				width: 100%;
				flex-flow: row wrap;
				align-content: space-between;
				
				@include for-tablet-portrait-up {
					width: 40%;
					padding-right: $spacing-mobile-half;
				}
				
				@include for-desktop-up {
					width: 45%;
				}
				
				.flex:last-of-type {
					padding-bottom: $spacing-mobile;
				}
				
				.right {
					@include for-tablet-landscape-up {
						text-align: right;
					}
				}
				
				.w_80.left {
					@include for-desktop-up {
						padding-right: 20%
					}
				}
				
				.w_80.right {
					@include for-desktop-up {
						padding-left: 20%
					}
				}
			}

			.col.text {
				position: relative;
			}
			
			.structure-3-2 {
				width: 100%;
				align-items: flex-start;
				justify-content: center;
				
				@include for-tablet-portrait-up {
					width: 60%;
					flex-flow: row nowrap;
					justify-content: end;
				}
				
				@include for-desktop-up {
					width: 55%;
				}
				
				.element:first-of-type {
					flex-basis: 50%;
					margin-right: $media-gap;

					@include for-desktop-up {
						flex-basis: 35%;
					}
				}
				
				.element:nth-of-type(2) {
					flex-basis: 50%;

					@include for-desktop-up {
						margin-right: $media-gap;
						flex-basis: 45%;
					}
				}
				
				.element:last-of-type {
					margin-top: 0;

					@include for-desktop-up {
						flex-basis: 25%;
					}
				}
			}
			
			.element {
				margin-top: $media-gap;
			}
			
		}
		
		.text {
			margin: 0;
		}
		
		.visible--mobile {
			display: flex;
			
			@include for-desktop-up {
				display: none;
			}
		}

		.visible--desktop {
			display: none;
			
			@include for-desktop-up {
				display: flex;
			}
		}
	}
</style>
